import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link as RouterLink, useLocation } from "react-router-dom";
import logoImage from "../../Pages/Image/knlogo.jpg";
import centralLogo from "../../Pages/Image/download.jpg";

function Navbar({ login, onLogout }) {
  const [isMobile, setIsMobile] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const location = useLocation();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navLinks = [
    { to: "/admin", label: "Dashboard" },
    { to: "/advertisement", label: "Advertisement" },
    { to: "/oldcar", label: "Old Car" },
    { to: "/contact-details", label: "Contact" },
    { to: "/service-request", label: "Service Request" },
    { to: "/book-test-drive", label: "Book Test Drive" },
    { to: "/vehicle-enquiry", label: "Vehicle Enquiry" },
    { to: "/enquiry", label: "Enquiry" },
    { to: "/quatation", label: "Quotations" },
  ];

  const renderNavButton = ({ to, label }) => (
    <Button
      key={to}
      component={RouterLink}
      to={to}
      sx={{
        color: location.pathname === to ? "#FFD700" : "white",
        fontSize: "13px",
        fontFamily: "KIAbodyLatinbasic_Regular",
        fontWeight: location.pathname === to ? "bold" : "normal",
        borderBottom: location.pathname === to ? "2px solid #FFD700" : "none",
        whiteSpace: "nowrap",
        "&:hover": { color: "#FFD700" },
      }}
    >
      {label}
    </Button>
  );

  return (
    <AppBar
      position="fixed"
      sx={{ backgroundColor: "rgba(0, 0, 0, 0.8)", height: 60, zIndex: 1201 }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
        {/* Logo Section */}
        <Box component={RouterLink} to="/admin" sx={{ display: "flex", alignItems: "center" }}>
          <img src={logoImage} alt="Logo" style={{ width: 38, marginRight: 8 }} />
          <img src={centralLogo} alt="Central" style={{ width: 60 }} />
        </Box>

        {/* Desktop Navigation */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1, flexGrow: 1, justifyContent: "flex-end" }}>
          {navLinks.map(renderNavButton)}
        </Box>

        {/* Avatar and Menu */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt="User Avatar"
            src={login?.profile_pic || login?.name}
            sx={{ width: 40, height: 40, cursor: "pointer" }}
            onClick={handleMenuOpen}
          />
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem component={RouterLink} to="/profile" onClick={handleMenuClose}>
              <AccountCircleIcon sx={{ mr: 1 }} /> Profile
            </MenuItem>
            <MenuItem
              onClick={() => {
                onLogout();
                handleMenuClose();
              }}
              component={RouterLink}
              to="/"
            >
              <LogoutIcon sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>

        {/* Mobile Toggle Button */}
        <IconButton
          sx={{ display: { xs: "flex", md: "none" }, color: "white" }}
          onClick={() => setIsMobile(!isMobile)}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Mobile Menu */}
      {isMobile && (
        <Box
          sx={{
            position: "absolute",
            top: 60,
            left: 0,
            right: 0,
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 1201,
            px: 2,
          }}
        >
          {navLinks.map(({ to, label }) => (
            <Button
              key={to}
              component={RouterLink}
              to={to}
              onClick={() => setIsMobile(false)}
              sx={{
                color: location.pathname === to ? "#FFD700" : "white",
                width: "100%",
                textAlign: "center",
                fontFamily: "KIAbodyLatinbasic_Regular",
                fontWeight: location.pathname === to ? "bold" : "normal",
              }}
            >
              {label}
            </Button>
          ))}
        </Box>
      )}
    </AppBar>
  );
};

export default Navbar;
